import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { CampaignBannerContentBlockWrapper } from './ContentBlocks/CampaignBannerContentBlockWrapper'
import { CategoryBrandingContentBlockWrapper } from './ContentBlocks/CategoryBrandingContentBlockWrapper'
import { CategoryGridContentBlockWrapper } from './ContentBlocks/CategoryGridContentBlockWrapper'
import { CompactCampaignBannerContentBlockWrapper } from './ContentBlocks/CompactCampaignBannerContentBlockWrapper'
import { GradientInfoHeaderContentBlockWrapper } from './ContentBlocks/GradientInfoHeaderContentBlockWrapper'
import { NotificationContentBlockWrapper } from './ContentBlocks/NotificationContentBlockWrapper'
import { RecipeGridContentBlockWrapper } from './ContentBlocks/RecipeGridContentBlockWrapper'
import { SimpleHeaderContentBlockWrapper } from './ContentBlocks/SimpleHeaderContentBlockWrapper'
import { SimpleTitleContentBlockWrapper } from './ContentBlocks/SimpleTitleContentBlockWrapper'
import { ValueBannerContentBlockWrapper } from './ContentBlocks/ValueBannerContentBlockWrapper'
import { WaveLinkHeaderContentBlockWrapper } from './ContentBlocks/WaveLinkHeaderContentBlockWrapper'
// TODO: fix library UI component positioning and remove these legacy boxes once we've fully migrated to UX land-on-menu
import { LegacyCampaignHeaderBox, LegacyHeaderBox } from './LegacyHeaderBoxes'

type RenderContentBlocksOptions = {
  collectionId?: string
}

const renderContentBlock = (
  contentBlock: MenuContentBlock,
  { collectionId }: RenderContentBlocksOptions,
) => {
  switch (contentBlock.type) {
    case 'category-grid':
      return <CategoryGridContentBlockWrapper contentBlock={contentBlock} />
    case 'simple-header':
      return <SimpleHeaderContentBlockWrapper contentBlock={contentBlock} />
    case 'simple-title':
      return <SimpleTitleContentBlockWrapper contentBlock={contentBlock} />
    case 'recipe-grid':
      return (
        <RecipeGridContentBlockWrapper contentBlock={contentBlock} collectionId={collectionId} />
      )
    case 'campaign-banner':
      return (
        <LegacyCampaignHeaderBox>
          <CampaignBannerContentBlockWrapper contentBlock={contentBlock} />
        </LegacyCampaignHeaderBox>
      )
    case 'compact-campaign-banner':
      return (
        <LegacyCampaignHeaderBox>
          <CompactCampaignBannerContentBlockWrapper contentBlock={contentBlock} />
        </LegacyCampaignHeaderBox>
      )
    case 'category-branding':
      return <CategoryBrandingContentBlockWrapper contentBlock={contentBlock} />
    case 'wave-link-header':
      return (
        <LegacyHeaderBox>
          <WaveLinkHeaderContentBlockWrapper contentBlock={contentBlock} />
        </LegacyHeaderBox>
      )
    case 'gradient-info-header':
      return (
        <LegacyHeaderBox>
          <GradientInfoHeaderContentBlockWrapper contentBlock={contentBlock} />
        </LegacyHeaderBox>
      )
    case 'notification':
      return <NotificationContentBlockWrapper contentBlock={contentBlock} />
    case 'value-banner':
      return <ValueBannerContentBlockWrapper contentBlock={contentBlock} />
    default:
      return null
  }
}

export const renderContentBlocks = (
  contentBlocks: MenuContentBlock[],
  options: RenderContentBlocksOptions = {},
) =>
  contentBlocks.map((contentBlock, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={`${contentBlock.type}-${index}`}>
      {renderContentBlock(contentBlock, options)}
    </React.Fragment>
  ))
